import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import Typography from '../../components/Typography/Typography';
import FieldList from './FieldList';
import useMetaData from '../../hooks/useMetaData';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';
import { jsonPathToValue } from '../../utils/json';
import { getVehicleOrder } from '../../services/order';
import TabLoader from './TabLoader';

const Order = () => {
  const { reservationId } = useParams<{ reservationId: string }>();
  const [data, setData] = useState<any>();
  const metaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.orderTab);

  useEffect(() => {
    if (reservationId) {
      getVehicleOrder(reservationId).then((response) => setData(response || {}));
    }
  }, [reservationId]);

  const orderFields = useMemo(
    () =>
      data
        ? metaData?.order?.rows?.map((row: any) => {
            const value = jsonPathToValue(data, row.property) || '';
            return {
              field: row?.propertyName,
              value: row.type === 'Date' ? value && moment(value).format('MMM D, YYYY') : value || '--',
            };
          }) || []
        : [],
    [data, metaData]
  );

  const ofacFields = useMemo(
    () =>
      data
        ? metaData?.ofac?.rows?.map((row: any) => {
            const value = jsonPathToValue(data, row.property);
            return {
              field: row?.propertyName,
              value: row.type === 'Date' ? value && moment(value).format('MMM D, YYYY') : value || '--',
            };
          }) || []
        : [],
    [data, metaData]
  );

  if (!metaData || !data) {
    return <TabLoader />;
  }

  return (
    <Box>
      <Typography size={12} weight={500} uppercase paddingLeft={1.5}>
        {metaData?.order?.name}
      </Typography>
      <FieldList fields={orderFields} />
      <Typography size={12} weight={500} uppercase paddingLeft={1.5}>
        {metaData?.ofac?.name}
      </Typography>
      <FieldList fields={ofacFields} />
    </Box>
  );
};

export default Order;
